import styled, { css } from "styled-components"

import Link from "~/components/atoms/Link"
import Typography from "~/components/atoms/Typography"
import { Color, RadiusSize, SpacingSize, Transition } from "~/consts/style-mixins"

interface Props {
  title: string
  upperDescription: string
  underDescription?: string
  thumbnailImagePath: string
  link: string
  className?: string
}

interface StyledProps {
  bgSrc: string
}

const CategoryCard = ({ title, upperDescription, underDescription, thumbnailImagePath, link, className }: Props) => {
  return (
    <div className={className}>
      <Link href={link}>
        <StyledWrapper>
          <StyledThumbnailImage bgSrc={thumbnailImagePath} />
          <StyledContentWrapper>
            <StyledTypographyHeading type="SubHeading">{title}</StyledTypographyHeading>
            <StyledTypographyCaption type="SubNote">{upperDescription}</StyledTypographyCaption>
            <StyledTypographyCaption type="SubNote">{underDescription}</StyledTypographyCaption>
          </StyledContentWrapper>
        </StyledWrapper>
      </Link>
    </div>
  )
}

const StyledWrapper = styled.div`
  border: 1px solid ${Color.BorderGray};
  ${Transition.Hover};
  border-radius: ${RadiusSize.Medium}px;
  &:hover {
    border: 1px solid ${Color.Primary};
  }
`
const StyledThumbnailImage = styled.div`
  width: 100%;
  height: 108px;
  border-radius: ${RadiusSize.Medium}px ${RadiusSize.Medium}px 0 0;
  background-size: cover;
  background-position: center center;
  ${({ bgSrc }: StyledProps) => css`
    background-image: url("${bgSrc}");
  `}
`

const StyledContentWrapper = styled.div`
  padding: ${SpacingSize.M}px ${SpacingSize.XS}px;
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-items: center;
  border-radius: 0 0 ${RadiusSize.Medium}px ${RadiusSize.Medium}px;
  background-color: ${Color.White};
`
const StyledTypographyHeading = styled(Typography)`
  margin-bottom: ${SpacingSize["3XS"]}px;
  color: ${Color.Black};
`
const StyledTypographyCaption = styled(Typography)`
  color: ${Color.Gray};
`
export default CategoryCard
